import CoreService from "../service/CoreService";

export default class Service extends CoreService {

}
